function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "XMLID_1353_"
}, /*#__PURE__*/React.createElement("g", {
  id: "XMLID_1647_"
}, /*#__PURE__*/React.createElement("g", {
  id: "XMLID_830_"
}, /*#__PURE__*/React.createElement("path", {
  id: "XMLID_888_",
  d: "m413.472 53.091v-18.617c0-10.184-4.466-19.79-12.252-26.354-7.785-6.563-18.006-9.342-28.044-7.621l-300.894 51.589.001.01c-4.717.804-8.312 4.901-8.312 9.847v440c0 5.522 4.478 10 10 10h329.5c24.537 0 44.5-19.963 44.5-44.5v-140.5c0-5.522-4.477-10-10-10-5.522 0-10 4.478-10 10v140.499c0 13.51-10.99 24.5-24.5 24.5h-319.5v-420h319.5c13.51 0 24.5 10.99 24.5 24.5v140.496c0 5.522 4.478 10 10 10 5.523 0 10-4.478 10-10v-140.496c.001-21.098-14.763-38.802-34.499-43.353zm-20-1.147h-201.997l185.081-31.732c4.215-.723 8.505.443 11.772 3.199 3.269 2.756 5.144 6.788 5.144 11.063z"
}), /*#__PURE__*/React.createElement("path", {
  id: "XMLID_889_",
  d: "m437.972 271.94c-2.641 0-5.21 1.07-7.07 2.93s-2.93 4.44-2.93 7.07c0 2.64 1.069 5.21 2.93 7.07 1.86 1.859 4.44 2.93 7.07 2.93s5.21-1.06 7.069-2.93c1.86-1.86 2.931-4.431 2.931-7.07 0-2.63-1.07-5.21-2.931-7.07-1.859-1.86-4.439-2.93-7.069-2.93z"
}), /*#__PURE__*/React.createElement("path", {
  id: "XMLID_892_",
  d: "m172.972 423.777h166c5.523 0 10-4.477 10-10 0-5.522-4.477-10-10-10h-2v-54.75c0-10.274-6.172-19.129-15-23.067v-40.933c0-13.923-11.327-25.25-25.25-25.25h-8.75v-22c0-5.522-4.477-10-10-10-5.522 0-10 4.478-10 10v22h-24v-22c0-5.522-4.478-10-10-10-5.523 0-10 4.478-10 10v22h-8.75c-13.923 0-25.25 11.327-25.25 25.25v40.933c-8.828 3.938-15 12.793-15 23.067v54.75h-2c-5.523 0-10 4.478-10 10s4.477 10 10 10zm37-138.75c0-2.895 2.355-5.25 5.25-5.25h81.5c2.895 0 5.25 2.355 5.25 5.25v38.75h-92zm-15 64c0-2.895 2.355-5.25 5.25-5.25h111.5c2.895 0 5.25 2.355 5.25 5.25v54.75h-122z"
}), /*#__PURE__*/React.createElement("path", {
  id: "XMLID_894_",
  d: "m172.972 173.451c5.522 0 10-4.478 10-10v-13.334c0-5.522-4.478-10-10-10-5.523 0-10 4.478-10 10v13.334c0 5.522 4.477 10 10 10z"
}), /*#__PURE__*/React.createElement("path", {
  id: "XMLID_895_",
  d: "m162.972 230.117c0 5.522 4.477 10 10 10 5.522 0 10-4.478 10-10v-13.333c0-5.523-4.478-10-10-10-5.523 0-10 4.477-10 10z"
}), /*#__PURE__*/React.createElement("path", {
  id: "XMLID_896_",
  d: "m199.639 200.117h13.333c5.522 0 10-4.478 10-10s-4.478-10-10-10h-13.333c-5.522 0-10 4.478-10 10s4.478 10 10 10z"
}), /*#__PURE__*/React.createElement("path", {
  id: "XMLID_897_",
  d: "m132.972 180.117c-5.523 0-10 4.478-10 10s4.478 10 10 10h13.333c5.523 0 10-4.478 10-10s-4.477-10-10-10z"
}), /*#__PURE__*/React.createElement("path", {
  id: "XMLID_898_",
  d: "m338.305 173.451c5.522 0 10-4.478 10-10v-13.334c0-5.522-4.478-10-10-10s-10 4.478-10 10v13.334c0 5.522 4.478 10 10 10z"
}), /*#__PURE__*/React.createElement("path", {
  id: "XMLID_899_",
  d: "m328.305 230.117c0 5.522 4.478 10 10 10s10-4.478 10-10v-13.333c0-5.523-4.478-10-10-10s-10 4.477-10 10z"
}), /*#__PURE__*/React.createElement("path", {
  id: "XMLID_900_",
  d: "m311.639 200.117c5.522 0 10-4.478 10-10s-4.478-10-10-10h-13.334c-5.522 0-10 4.478-10 10s4.478 10 10 10z"
}), /*#__PURE__*/React.createElement("path", {
  id: "XMLID_901_",
  d: "m364.972 180.117c-5.522 0-10 4.478-10 10s4.478 10 10 10h13.333c5.522 0 10-4.478 10-10s-4.478-10-10-10z"
}))));

var SvgInfo = function SvgInfo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 511.944 511.944",
    viewBox: "0 0 511.944 511.944",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInfo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/info.1973593d.svg";
export { ForwardRef as ReactComponent };